<script lang="ts">
    import Account from "./account/Account.svelte"
    import Balance from "./account/components/Balance/Balance.svelte"
    import Withdrawal from "./withdrawal/Withdrawal.svelte"
    import Activity from "./activity/Activity.svelte"
    import Notifications from "./notifications/Notifications.svelte"
    import Inventory from "./inventory/Inventory.svelte"
    import Mint from 'src/components/cabinet/inventory/components/mint/Mint.svelte'
    import InventoryCategory from "./inventory/components/category/Category.svelte"
    import InventoryUnit from "src/components/cabinet/inventory/components/unit/Unit.svelte"
    import InventoryEgg from "src/components/cabinet/inventory/components/egg/Egg.svelte"
    import Memberships from "./memberships/Memberships.svelte"
    import Referrals from "./referrals/Referrals.svelte"
    import AllReferrals from "./referrals/components/All.svelte"
    import Spin from "./spin/Spin.svelte"
    import Swap from "./swap/Swap.svelte"
    import Staking from "./staking/Staking.svelte"
    import Settings from "./settings/Settings.svelte"
    import SettingsPasswordChange from "./settings/components/password-change/PasswordEdit.svelte"
    import SettingsPasswordSet from "./settings/components/password-set/PasswordSet.svelte"
    import RouteAuthOnly from "src/components/cabinet/#common/authOnly/RouteAuthOnly.svelte";
    // import SettingsEmail from "./settings/components/email-change/EmailEdit.svelte"
</script>

<RouteAuthOnly path="account"><Account/></RouteAuthOnly>
<RouteAuthOnly path="balance/:balance" let:params><Balance balance={params.balance}/></RouteAuthOnly>
<RouteAuthOnly path="withdrawal"><Withdrawal/></RouteAuthOnly>
<RouteAuthOnly path="activity"><Activity/></RouteAuthOnly>
<RouteAuthOnly path="inventory"><Inventory/></RouteAuthOnly>
<RouteAuthOnly path="inventory/:category" let:params><InventoryCategory category={params.category}/></RouteAuthOnly>
<!--<RouteAuthOnly path="inventory/mint"><Mint/></RouteAuthOnly>-->
<RouteAuthOnly path="inventory/unit/:id" let:params><InventoryUnit id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="inventory/egg/:id" let:params><InventoryEgg id={params.id}/></RouteAuthOnly>
<RouteAuthOnly path="notifications"><Notifications/></RouteAuthOnly>
<RouteAuthOnly path="memberships"><Memberships/></RouteAuthOnly>
<RouteAuthOnly path="referrals"><Referrals/></RouteAuthOnly>
<RouteAuthOnly path="referrals/all"><AllReferrals/></RouteAuthOnly>
<!--<RouteAuthOnly path="spin"><Spin/></RouteAuthOnly>-->
<RouteAuthOnly path="swap"><Swap/></RouteAuthOnly>
<RouteAuthOnly path="staking"><Staking/></RouteAuthOnly>
<RouteAuthOnly path="settings/:hash" let:params><Settings hash={params.hash}/></RouteAuthOnly>
<RouteAuthOnly path="settings"><Settings/></RouteAuthOnly>
<!--<RouteAuthOnly path="settings/email"><SettingsEmail/></RouteAuthOnly>-->
<RouteAuthOnly path="settings/password-change"><SettingsPasswordChange/></RouteAuthOnly>
<RouteAuthOnly path="settings/password-set"><SettingsPasswordSet/></RouteAuthOnly>
